<template>
  <yv-form-search
    :formSearch="baseFormSearch"
    :inlineSearchAction="true"
    :enableExport="false"
    @search="search"
    ref="formReport"
  >
    <template #search-actions="{ actions }">
      <md-button
        native-type="submit"
        @click.native.prevent="actions.search"
        class="md-info md-round"
        >{{ $t("common.report") }}
      </md-button>
    </template>
  </yv-form-search>
</template>

<script>
import YvFormSearch from "@/components/Base/YvFormSearch.vue";
import { Message, getId } from "@/helpers/utils";
import { service_paths } from "@/constants/Services";
import { attendanceStatus } from "../../../../helpers/text-helper";
import moment from "moment";
import { convertDateFromServer } from "../../../../helpers/datetime-helper";

export default {
  components: { YvFormSearch },
  data() {
    return {
      baseFormSearch: [
        {
          label: this.$t("class.filter_by_name"),
          name: "class_id",
          value: "",
          displayValue: "",
          options: [],
          type: "autocomplete",
          fields: {
            text: "name",
            value: "id"
          },
          searchKey: "classes__name__~",
          refetchOptions: this.fetchClasses,
          width: 25
        },
        {
          label: this.$t("daily_attendance.date"),
          name: "range_date",
          value: [],
          type: "date-range",
          width: 25
        },
        {
          label: this.$t("common.status"),
          name: "status[]",
          value: [],
          type: "checkbox-multi-select",
          options: [],
          trackBy: "statusId",
          displayField: "text",
          showSelectAll: true,
          width: 25
        },
        {
          label: this.$t("class.student_filter_id_fullname"),
          name: "user_id",
          value: "",
          displayValue: "",
          options: [],
          type: "autocomplete",
          fields: {
            text: "name",
            value: "id"
          },
          searchKey: "search",
          refetchOptions: this.fetchStudentOptsByClass,
          width: 25
        }
      ],
      selectedDateValue: ""
    };
  },
  computed: {
    selectedClassId() {
      return this.baseFormSearch[0].value;
    }
  },
  created() {
    const status = [];
    for (let key in attendanceStatus) {
      status.push({ statusId: key, text: attendanceStatus[key] });
    }
    this.baseFormSearch[2].options = status;
    const defaultStatus = ["Ex.absence", "Unex.absence"];
    this.baseFormSearch[2].value = [...defaultStatus];
    this.fetchClasses();
  },
  watch: {
    selectedClassId: function(newSelectedClassId) {
      this.baseFormSearch[3].isDisabled = false;
      if (!newSelectedClassId) {
        this.baseFormSearch[3].options = [];
        this.baseFormSearch[3].displayValue = "";
        this.baseFormSearch[3].value = "";
        this.baseFormSearch[3].isDisabled = true;
        return;
      }
      this.fetchStudentOptsByClass();
    },
    selectedStudentId: function(newSelectedStudentId) {
      return newSelectedStudentId;
    }
  },

  methods: {
    search(queryParams) {
      if (!this.baseFormSearch[0].value || !this.baseFormSearch[1].value) {
        Message.error(this.$t("daily_attendance.no_selected"));
        return;
      }
      if (
        queryParams["status[]"].length === 5 ||
        queryParams["status[]"].length === 0
      ) {
        queryParams["status[]"] = "";
      }
      queryParams.start_date = moment(queryParams.range_date[0]).format(
        "YYYY-MM-DD 00:00:00"
      );
      queryParams.end_date = moment(queryParams.range_date[1]).format(
        "YYYY-MM-DD 23:59:59"
      );
      queryParams.class_status = "On-going";
      delete queryParams.range_date;
      this.$emit("dailyReport", queryParams);
    },
    async getDateOption(classId) {
      let dates = await this.$axios
        .get(`${service_paths.classes}/${classId}/calendar`, { limit: 100 })
        .then(response => response.data.data);
      if (dates.length) {
        this.baseFormSearch[1].options = dates.map(date => {
          let dateFormat = convertDateFromServer(date.end, "date");
          let rawDate = date.end;
          return { id: date["_id"], name: dateFormat, rawDate };
        });
      } else {
        this.baseFormSearch[1].options = [];
      }
    },

    onSelectedDate(dateId) {
      if (!dateId) return;
      let dates = this.baseFormSearch[1].options;
      let date = dates.find(date => date.id === dateId).rawDate;
      this.selectedDateValue = /^\d{4}-\d{2}-\d{2}$/.test(date)
        ? moment(date).format("YYYY-MM-DD 00:00:00")
        : moment(date)
            .utcOffset(0)
            .format("YYYY-MM-DD HH:mm:ss");
    },
    fetchStudentOptsByClass(queryObj) {
      return this.$axios
        .get(
          `${service_paths.classes}/${this.selectedClassId}/students`,
          queryObj,
          undefined,
          undefined,
          undefined,
          undefined,
          false
        )
        .then(response => {
          let options = [];
          response.data.data.forEach(student => {
            options.push({
              id: getId(student),
              name: student.student_code
                ? `${student.full_name} - ${student.student_code}`
                : student.full_name
            });
          });
          this.baseFormSearch[3].options = options;
        });
    },
    fetchClasses(query) {
      const queryParams = {
        ...query,
        limit: 30
      };
      return this.$axios
        .get(
          `${service_paths.classes}/current-user`,
          queryParams,
          undefined,
          undefined,
          undefined,
          undefined,
          false
        )
        .then(response => {
          const classes = response.data.data;
          let classList = classes.map(classObj => ({
            id: getId(classObj),
            name: classObj.name
          }));
          this.baseFormSearch[0].options = classList;
        });
    }
  }
};
</script>

<style lang="scss" scoped></style>
